import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('selectReplyOption')(function selectReplyOption(replyAllByDefault, state) {
    var optionState = state.optionState;
    optionState.replyAllByDefault = replyAllByDefault;
}));
//# sourceMappingURL=selectReplyOption.js.map